import DateTime from './DateTime/DateTime';
var DateTimeFormatHelper = {
    getFormatDate: function (dateTimeString: string, forceShowSeconds: boolean = false) {
        var d = new DateTime({ date: dateTimeString, ignoreTime: false, forceShowSeconds, convertToTimezone: true });
        return d.toDateString();
    },

    getFormatTime: function (dateTimeString: string, forceShowSeconds: boolean = false, convertToTimezone:boolean = true) {
        var d = new DateTime({ date: dateTimeString, ignoreTime: false, forceShowSeconds, convertToTimezone: convertToTimezone });
        return d.toTimeString();
    }
}
export default DateTimeFormatHelper;